import React from 'react';
import { CheckCircle2, Loader2, PenLine, RefreshCw } from 'lucide-react';

// Riquadro in Documenti: quante firme mancano, controllo in corso, apri l'elenco
export const FirmeCard = ({ dati, onApri, onRicontrolla }) => {
  if (!dati || dati.errore) return null;
  const { verifica: v, mancanti, con_mancanti: conMancanti } = dati;
  return (
    <div className={`rounded-2xl border p-4 space-y-2 ${mancanti ? 'border-amber-300 bg-amber-50' : 'border-emerald-200 bg-emerald-50'}`} data-testid="firme-card">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${mancanti ? 'bg-amber-500' : 'bg-emerald-600'}`}>
          {mancanti ? <PenLine className="h-5 w-5 text-white" /> : <CheckCircle2 className="h-5 w-5 text-white" />}
        </div>
        <div className="min-w-0 flex-1">
          <p className="font-bold text-gray-900" data-testid="firme-card-titolo">
            {mancanti ? `${mancanti} firme mancanti in ${conMancanti} documenti` : v.in_corso ? 'Controllo le firme...' : 'Nessuna firma mancante'}
          </p>
          {v.in_corso
            ? <p className="text-xs text-gray-600 flex items-center gap-1.5" data-testid="firme-card-progresso"><Loader2 className="h-3.5 w-3.5 animate-spin" />Leggo i documenti: {v.fatti} di {v.totale}</p>
            : <p className="text-xs text-gray-600">Ho guardato ogni documento per trovare gli spazi da firmare.{dati.errori ? ` ${dati.errori} non letti.` : ''}</p>}
        </div>
      </div>
      <div className="flex gap-2">
        <button onClick={onApri} data-testid="firme-apri-btn" className="flex-1 h-11 rounded-full bg-gray-900 text-white text-sm font-semibold flex items-center justify-center gap-2">
          <PenLine className="h-4 w-4" />{mancanti ? 'Vedi e firma' : 'Vedi le firme'}
        </button>
        <button onClick={onRicontrolla} disabled={v.in_corso} data-testid="firme-ricontrolla-btn" title="Ricontrolla tutti i documenti"
          className="h-11 w-11 rounded-full border border-gray-300 flex items-center justify-center text-gray-700 disabled:opacity-50"><RefreshCw className="h-4 w-4" /></button>
      </div>
    </div>
  );
};
